import {
  INTERNAL_SESSION_START,
  INTERNAL_CALL_RELEASE,
  INTERNAL_NETWORK_DISCONNECT,
  INTERNAL_CALLBACK_RELEASE,
  // INTERNAL_CHAT_RELEASE,
  INTERNAL_CASE_RELEASE,
  BG_HISTORY_CHANGE,
} from "../constants/events";
// import { emitter, SessionEvent } from '../emitter';
// import { Call } from '../reducers/call';
// import {
//     addCallbackToHistoryAction,
//     addCallToHistoryAction,
//      initializeHistory,
//     addChatToHistoryAction,
//     addCaseToHistoryAction,
// } from '../actions/history';
// import { store } from '../store';
import storeRTK from "../store/storeRTK";
import {
  addCallbackToHistoryAction,
  addCallToHistoryAction,
  initializeHistory,
  addChatToHistoryAction,
  addCaseToHistoryAction,
} from "../connector/history";
import Emitter from "../emitter";
import { setHistoryState } from "../actions/history";
import { Callback } from "../types/callback.type";
import { Call } from "../types/call.type";

function historyHandler(event: Call) {
  if (event) {
    storeRTK.dispatch(addCallToHistoryAction(event));
  }
}
function historyHandlerForCallback(event: Callback) {
  if (event) {
    storeRTK.dispatch(addCallbackToHistoryAction(event));
  }
}
// function historyHandlerForChat(event: any) {
//   if (event.body) {
//     storeRTK.dispatch(addChatToHistoryAction(event.body));
//   }
// }

export function historyInitialiseHandler() {
  storeRTK.dispatch(initializeHistory(null));
}
function historyHandlerOnNetworkDisconnect() {
  const state = storeRTK.getState();
  if (state.call.id && state.call.self?.state !== "RELEASED") {
    storeRTK.dispatch(addCallToHistoryAction(state.call));
  }
  if (
    state.callback.id &&
    state.callback.self?.callback?.state !== "RELEASED"
  ) {
    storeRTK.dispatch(addCallbackToHistoryAction(state.callback));
  }
  playerHandlerOnNetworkDisconnect();
}
function playerHandlerOnNetworkDisconnect() {
  // No audio management needed here anymore
}

// For case
function historyHandlerForCase(event: any) {
  if (event.body) {
    storeRTK.dispatch(addCaseToHistoryAction(event.body));
  }
}
/**
 * Set Data to history
 * @param {*} messageEnvelope
 */
function setHistory(messageEnvelope: any) {
  if (messageEnvelope.body) {
    storeRTK.dispatch(setHistoryState(messageEnvelope.body));
  }
}
export default function registerHistoryHandlers() {
  Emitter.on(INTERNAL_CALL_RELEASE, historyHandler);
  Emitter.on(INTERNAL_SESSION_START, historyInitialiseHandler);
  Emitter.on(INTERNAL_NETWORK_DISCONNECT, historyHandlerOnNetworkDisconnect);
  Emitter.on(INTERNAL_CALLBACK_RELEASE, historyHandlerForCallback);
  // Emitter.on(INTERNAL_CHAT_RELEASE, historyHandlerForChat);
  Emitter.on(INTERNAL_CASE_RELEASE, historyHandlerForCase);
  Emitter.on(BG_HISTORY_CHANGE, setHistory);
}
